(function () {
	const header = () => {
		const header = document.querySelector(".shopify-section-header");
		if (!header || header.dataset.headerInitialized === "true") return;
		header.dataset.headerInitialized = "true";

		const headerAlways = document.querySelector(".header-always");

		if (headerAlways) {
			header.classList.add("always-show");
		}

		const menu = document.querySelector(".list-menu--inline");
		const menuLinks = document.querySelectorAll(".list-menu-item");
		const search = document.querySelector(".header__search");

		header.addEventListener("keydown", (e) => {
			if (e.code === "Escape" && search?.isOpen) {
				search.close();
			}
		});

		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);

		const annBar = document.querySelector(".section-announcement");
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries;

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					"--ann-height",
					`${entry.intersectionRect.height}px`
				);
			} else {
				document.documentElement.style.setProperty("--ann-height", `0px`);
			}
		});
		if (annBar) annBarObserver.observe(annBar);

		//menuLinks &&
		//	menuLinks.forEach((link) => {
		//		link.addEventListener("mouseenter", (e) => {
		//			if (link.classList.contains("list-menu--megamenu")) {
		//				link.classList.add("list-menu--megamenu-visible");
		//				if (
		//					header.classList.contains("color-background-2") &&
		//					!header.classList.contains("shopify-section-header-sticky")
		//				) {
		//					header.classList.remove("color-background-2");
		//				}

		//				menuLinks.forEach((el) => {
		//					if (el !== link) {
		//						el.classList.remove("list-menu--megamenu-visible");
		//					}
		//				});
		//			} else {
		//				menuLinks.forEach((el) => {
		//					el.classList.remove("list-menu--megamenu-visible");
		//				});
		//			}
		//		});
		//	});
		//menu &&
		//	menu.addEventListener("mouseleave", (e) => {
		//		menuLinks.forEach((link) => {
		//			link.classList.remove("list-menu--megamenu-visible");
		//		});
		//	});

		const canChangeTransparentHeader = () => {
			return (
				window.matchMedia("(min-width: 1200px)").matches &&
				!header.classList.contains("shopify-section-header-sticky") &&
				!document.querySelector(".always-show")
			);
		};

		const addBackground = () => {
			if (document.querySelector(".overflow-hidden-drawer")) {
				return;
			}

			if (!canChangeTransparentHeader()) {
				return;
			}

			if (header.classList.contains("color-background-2")) {
				header.classList.remove("color-background-2");
			}

			if (header.classList.contains("section--have-overlay")) {
				header.classList.add("have-background");
			}
		};

		const removeBackground = () => {
			if (
				document.querySelector(".overflow-hidden") ||
				document.querySelector(".overflow-hidden-drawer")
			) {
				return;
			}

			if (!canChangeTransparentHeader()) {
				return;
			}

			if (header.classList.contains("color-background-1")) {
				header.classList.add("color-background-2");
			}

			if (header.classList.contains("section--have-overlay")) {
				header.classList.remove("have-background");
			}
		};

		header.addEventListener("mouseenter", addBackground);

		header.addEventListener("focus", addBackground);

		header.addEventListener("focusin", addBackground);

		header.addEventListener("mouseleave", removeBackground);

		header.addEventListener("focusout", removeBackground);

		document.addEventListener("DOMContentLoaded", () => {
			const firstSection = document.querySelector("main .shopify-section:first-child:not(.not-margin) .section--has-overlay:not(.article-template__header)");
			let isSectionVisible = false;
			const observer = new IntersectionObserver(
				([entry]) => {
					if (entry.isIntersecting && !isSectionVisible) {
						isSectionVisible = true;
						header.classList.add("entering-section", "color-background-2");
					} else if (!entry.isIntersecting && isSectionVisible) {
						isSectionVisible = false;
						header.classList.remove("entering-section");
					}
				},
				{ threshold: 0.15 }
			);

			if (firstSection) {
				observer.observe(firstSection);
			}

			header.addEventListener("mouseenter", () => {
				if (
					isSectionVisible
				) {
					header.classList.remove("color-background-2");
				}
			});

			header.addEventListener("mouseleave", () => {
				if (
					isSectionVisible
				) {
					header.classList.add("color-background-2");
				}
			});
		});

		//const megaMenuListLinks = () => {
		//	const megaMenuLinkWithSubmenu = document.querySelector(
		//		".mega-menu__list-item--children"
		//	);
		//	const megaMenuLinks = document.querySelectorAll(".mega-menu__list-item");
		//	if (megaMenuLinkWithSubmenu) {
		//		megaMenuLinks.forEach((link) => {
		//			link.classList.add("mega-menu__list-item--opacity");
		//		});
		//		megaMenuLinkWithSubmenu.classList.remove(
		//			"mega-menu__list-item--opacity"
		//		);
		//		megaMenuLinkWithSubmenu.classList.add("mega-menu__list-item--visible");
		//	}
		//	$(".mega-menu__list-item").mouseenter(function (event) {
		//		if (megaMenuLinkWithSubmenu) {
		//			megaMenuLinkWithSubmenu.classList.remove(
		//				"mega-menu__list-item--visible"
		//			);
		//		}
		//		$(this).removeClass("mega-menu__list-item--opacity");
		//		$(this).siblings().addClass("mega-menu__list-item--opacity");
		//		$(this).mouseleave(() => {
		//			$(this).siblings().removeClass("mega-menu__list-item--opacity");
		//		});
		//	});
		//	$(".mega-menu__list-item").focus(function (event) {
		//		if (megaMenuLinkWithSubmenu) {
		//			megaMenuLinkWithSubmenu.classList.remove(
		//				"mega-menu__list-item--visible"
		//			);
		//		}
		//		$(this).removeClass("mega-menu__list-item--opacity");
		//		$(this).siblings().addClass("mega-menu__list-item--opacity");
		//		$(this).mouseleave(() => {
		//			$(this).siblings().removeClass("mega-menu__list-item--opacity");
		//		});
		//	});
		//};

		//const megaMenuSublinks = () => {
		//	$(".mega-menu--list .mega-menu__submenu-item").mouseenter(function (
		//		event
		//	) {
		//		$(this).removeClass("mega-menu__submenu-item--opacity");
		//		$(this)
		//			.parent()
		//			.siblings()
		//			.find(".mega-menu__submenu-item")
		//			.addClass("mega-menu__submenu-item--opacity");
		//		$(this).mouseleave(() => {
		//			$(this)
		//				.parent()
		//				.siblings()
		//				.find(".mega-menu__submenu-item")
		//				.removeClass("mega-menu__submenu-item--opacity");
		//		});
		//	});
		//	$(".mega-menu--list .mega-menu__submenu-item").focusin(function (event) {
		//		$(this).removeClass("mega-menu__submenu-item--opacity");
		//		$(this)
		//			.parent()
		//			.siblings()
		//			.find(".mega-menu__submenu-item")
		//			.addClass("mega-menu__submenu-item--opacity");
		//		$(this).focusout(() => {
		//			$(this)
		//				.parent()
		//				.siblings()
		//				.find(".mega-menu__submenu-item")
		//				.removeClass("mega-menu__submenu-item--opacity");
		//		});
		//	});
		//};
		//megaMenuListLinks();
		//megaMenuSublinks();

		const main = document.querySelector("main");
		const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
		if (
			main
				.querySelector(".shopify-section")
				?.classList.contains("section--has-overlay") &&
			!main
				.querySelector(".shopify-section")
				?.classList.contains("not-margin")
		) {
			header.classList.add("color-background-1", "color-background-2");
			if (breadcrumbs) {
				breadcrumbs.classList.add("color-background-2");
			}
		}
		const initMobileDrawer = () => {
			const drawer = document.querySelector("header-drawer");
			if (!drawer) return;

			const navContainer = drawer.querySelector(".menu-drawer__navigation-container");
			const primaryView = drawer.querySelector('[data-drawer-view="primary"]');
			const secondaryView = drawer.querySelector('[data-drawer-view="secondary"]');
			const tabs = Array.from(drawer.querySelectorAll("[data-drawer-tab]"));
			const panels = Array.from(drawer.querySelectorAll("[data-drawer-panel]"));
			const secondaryPanels = Array.from(
				drawer.querySelectorAll(".menu-drawer__secondary-panel")
			);

			if (!navContainer || !primaryView || !secondaryView) return;

			const scrollToTop = (el) => {
				if (!el) return;
				el.scrollTop = 0;
			};

			const setActiveTab = (target) => {
				const tabName = target.getAttribute("data-drawer-tab");
				if (!tabName) return;

				tabs.forEach((tab) => {
					const isActive = tab === target;
					tab.classList.toggle("menu-drawer__tab--active", isActive);
					tab.setAttribute("aria-selected", isActive ? "true" : "false");
				});

				panels.forEach((panel) => {
					const match = panel.getAttribute("data-drawer-panel") === tabName;
					panel.hidden = !match;
				});

				scrollToTop(primaryView);
			};

			const showSecondaryPanel = (menuName, index) => {
				const panel = secondaryPanels.find(
					(p) =>
						p.getAttribute("data-secondary-menu") === menuName &&
						p.getAttribute("data-secondary-index") === String(index)
				);
				if (!panel) return;

				primaryView.classList.add("is-hidden");
				secondaryView.classList.add("is-active");

				secondaryPanels.forEach((p) => {
					p.classList.toggle("is-active", p === panel);
				});

				scrollToTop(secondaryView);
				const backButton = panel.querySelector("[data-drawer-back]");
				if (backButton) backButton.focus();
			};

			const hideSecondary = () => {
				secondaryView.classList.remove("is-active");
				primaryView.classList.remove("is-hidden");
				secondaryPanels.forEach((p) => {
					p.classList.remove("is-active");
				});
				scrollToTop(primaryView);
			};

			// Initial active tab based on gender, if available
			if (tabs.length) {
				let initialTab = tabs[0];
				const currentGender =
					window.genderManager?.getCurrentGender?.() || window.gender || null;

				if (currentGender) {
					const genderMatch = tabs.find(
						(tab) => tab.getAttribute("data-gender") === currentGender
					);
					if (genderMatch) {
						initialTab = genderMatch;
					}
				}

				setActiveTab(initialTab);
			}

			// Keep tab selection in sync if gender changes without full reload
			if (!drawer.dataset.genderListenerAdded) {
				drawer.dataset.genderListenerAdded = "true";

				document.addEventListener("genderChanged", (event) => {
					const targetGender = event?.detail?.gender;
					if (!targetGender) return;

					const genderMatch = tabs.find(
						(tab) => tab.getAttribute("data-gender") === targetGender
					);
					if (!genderMatch) return;

					// If the user is currently viewing a drilled-in submenu, reset
					// to primary view to avoid showing mismatched content.
					if (secondaryView.classList.contains("is-active")) {
						hideSecondary();
					}

					setActiveTab(genderMatch);
				});
			}

			navContainer.addEventListener("click", (event) => {
				const tabButton = event.target.closest("[data-drawer-tab]");
				if (tabButton) {
					event.preventDefault();

					const targetGender = tabButton.getAttribute("data-gender");
					const currentGender =
						window.genderManager?.getCurrentGender?.() || window.gender || null;

					// If the tab is gender-aware, persist gender selection in the
					// gender manager so the drawer auto-selects it next open.
					setActiveTab(tabButton);

					if (
						targetGender &&
						currentGender &&
						window.genderManager &&
						targetGender !== currentGender
					) {
						window.genderManager.setGenderForced(targetGender);
					}
					return;
				}

				const parentTrigger = event.target.closest(".menu-drawer__item--has-children");
				if (parentTrigger) {
					event.preventDefault();
					const menuName = parentTrigger.getAttribute("data-parent-menu");
					const index = parentTrigger.getAttribute("data-parent-index");
					showSecondaryPanel(menuName, index);
					return;
				}

				const backButton = event.target.closest("[data-drawer-back]");
				if (backButton) {
					event.preventDefault();
					hideSecondary();
					return;
				}

				const closeButton = event.target.closest("[data-drawer-close]");
				if (closeButton) {
					event.preventDefault();
					const details = drawer.querySelector(".menu-drawer-container");
					if (!details || !details.open) return;

					// Close via the summary trigger so the theme's native drawer cleanup runs
					// (removes overflow-hidden-tablet, resets hamburger/X icon state, etc.)
					const summary = details.querySelector("summary");
					if (summary) {
						summary.click();
						hideSecondary();
						return;
					}

					details.open = false;
					hideSecondary();
				}
			});
		};

		initMobileDrawer();
	};

	header();

	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);
})();
